module.exports = __webpack_public_path__ + "media/images/countdown__background-f8c03d5639d70a93e544feaba6d273ef.jpg";